import React from "react";
import { Box, Button, FormControlLabel, Paper, Radio, RadioGroup, Stack, Typography } from "@mui/material";

export default function BasketCheckoutPanel({ strategy, onStrategyChange, onCheckout }) {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Warenkorb & Checkout
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Wählen Sie, wie die Lieferanten pro Bestellung ausgewählt werden sollen.
      </Typography>
      <RadioGroup value={strategy} onChange={(event) => onStrategyChange?.(event.target.value)}>
        <FormControlLabel value="CHEAPEST_BASKET" control={<Radio />} label="Günstigster Gesamtwarenkorb" />
        <FormControlLabel value="CHEAPEST_PER_LINE" control={<Radio />} label="Pro Position günstigster Lieferant" />
      </RadioGroup>
      <Box sx={{ mt: 3 }}>
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="contained" onClick={onCheckout}>
            Bestellung auslösen
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
}
